import type { Writable } from "svelte/store";
import type { Component } from "../editor";

export type MenuGroupItem = {
    type: "group";
    name: string;
    items: MenuSubItem[];
    enabled?: Writable<boolean>;

    left?: Component;
    right?: Component;
};
export type MenuSeparatorItem = { type: "sep" };
export type MenuActionItem = {
    type: "action";
    name: string;
    action: () => void;
    enabled?: Writable<boolean>;

    left?: Component;
    right?: Component;
};
export type MenuSubItem = MenuGroupItem | MenuActionItem | MenuSeparatorItem;

export function createMenuBar(items: MenuGroupItem[]): MenuGroupItem[] {
    return items;
}

export function group(
    name: string,
    items: MenuSubItem[],
    enabled?: Writable<boolean>,
    { left, right }: { left?: Component; right?: Component } = {}
): MenuGroupItem {
    return { type: "group", name, items, enabled, left, right };
}

export function separator(): MenuSeparatorItem {
    return { type: "sep" };
}

export function action(
    name: string,
    action: () => void,
    enabled?: Writable<boolean>,
    { left, right }: { left?: Component; right?: Component } = {}
): MenuActionItem {
    return { type: "action", name, action, enabled, left, right };
}
